import { Controller } from "@hotwired/stimulus";

// Realtime dashboard updates arrive via turbo_stream_from (see _dashboard_locate).
// The custom locate_* Turbo Stream actions (application.js) do the DOM update and
// announce a "locate:activity" event whose kind the server set. This controller
// runs the matching side effects: Semantic UI re-init, unread badges, message
// input focus, and desktop notifications.
export default class extends Controller {
  static targets = ["errorText", "phoneNumber"];

  connect() {
    this.onActivity = this.handleActivity.bind(this);
    document.addEventListener("locate:activity", this.onActivity);
  }

  disconnect() {
    document.removeEventListener("locate:activity", this.onActivity);
  }

  clearForm(event) {
    $(event.currentTarget).find("input").val("");
    this.errorTextTarget.innerText = "";
    this.errorTextTarget.classList.remove("error");
    this.phoneNumberTarget.classList.remove("error");
  }

  displayError(event) {
    const phoneNumber = this.phoneNumberTarget.value;
    this.phoneNumberTarget.classList.add("error");
    this.errorTextTarget.classList.add("error");
    switch (phoneNumber) {
      case "":
        this.errorTextTarget.innerText = "The phone number field is blank.";
        break;

      default:
        this.errorTextTarget.innerText = `${phoneNumber} is not recognized as a valid phone number.`;
        break;
    }
  }

  handleActivity(event) {
    const { kind, target } = event.detail;
    this.showUnread(this.tab);
    this.dispatchLocalNotification();

    switch (kind) {
      case "added":
        document.getElementById("locate-empty")?.remove();
        break;
      case "message":
        this.showUnread(this.subTab(target, "messageTab"));
        document.getElementById(`${target}-input`)?.focus();
        break;
      case "location":
        this.showUnread(this.subTab(target, "locationTab"));
        break;
    }
  }

  subTab(target, name) {
    const card = document.getElementById(target)?.closest(".location-request");
    return card?.querySelector(`[data-location-request-target="${name}"]`);
  }

  dispatchLocalNotification() {
    const windowIsVisible = document.visibilityState == "visible";
    const activeTab = this.tab.classList.contains("active");
    if (windowIsVisible && activeTab) {
      return;
    }
    this.dispatch("notify", { detail: "Locate Request Updated" });
  }

  get tab() {
    return document.querySelector(`.tabs-dashboard [data-tab="locate"]`);
  }

  removeUnread() {
    this.tab.classList.remove("unread");
  }

  showUnread(tab) {
    if (tab && !tab.classList.contains("active")) {
      tab.classList.add("unread");
    }
  }
}
